<template>
  <div class="text-center" style="position: relative !important; z-index: 99999 !important;">
    <v-bottom-sheet v-model="isMostraSheetFooter" transition="bottom-sheet-transition">
      <v-sheet
        class="text-center"
        height="200px"
        style="position: relative !important; z-index: 99999 !important;"
      >
        <v-btn
          class="mt-6"
          text
          color="red"
          @click="close()"
        >
          Fechar
        </v-btn>
        <div class="py-3 text-h5">
          {{ msgSheetFooter }}
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>

import {mapState, mapMutations} from 'vuex'


export default {
  data: () => ({
  }),
  methods: {
    ...mapMutations({
      commitMostrarSheet: 'system/SET_MOSTRAR_SHEET',
      commitMsgSheet: 'system/SET_MSG_SHEET',
    }),
    close() {
      this.commitMostrarSheet(false)
      this.commitMsgSheet(null)
    },
    iniciarContador() {
      setTimeout(() => {
        this.close()
      }, 5000);
    }
  },
  watch: {
    isMostraSheetFooter(newValue) {
      if (newValue) {
        this.iniciarContador()
      }
    },
  },

  computed: {
    ...mapState("system", ["isMostraSheetFooter", 'msgSheetFooter']),
  },
}

</script>


// WEBPACK FOOTER //
// src/components/core/sheetFooter.vue